import React from 'react';
import { DropdownMenu, DropdownSectionHeader, MenuItem, DropdownSection } from '@fiverr-private/dropdown';
import { type Link } from '../../shared/getContentLinks';

interface DropdownColumnContentProps {
    title: string;
    links: Link[];
    onClick?: (link: Link) => void;
}

export const DropdownColumnContent = ({ title, links, onClick }: DropdownColumnContentProps) => (
    <DropdownSection>
        <DropdownSectionHeader>{title}</DropdownSectionHeader>
        <DropdownMenu>
            {links.map(({ url, label, bigQueryEventName }) => (
                <MenuItem
                    key={url}
                    href={url}
                    target="_blank"
                    onClick={() => onClick?.({ url, label, bigQueryEventName })}
                >
                    {label}
                </MenuItem>
            ))}
        </DropdownMenu>
    </DropdownSection>
);
